<template>
  <transition name="fade">
    <div :class="{ 'sticky-wrapper': sticky }">
      <div :class="{ container: sticky }" v-show="!sticky || shouldShowSticky">
        <div :class="{ 'justify-content-between py-1': sticky }" class="d-flex align-items-center">
          <div :class="{ 'my-n1 mw-100': sticky }" class="nt-Tabs_Wrapper">
            <tab-nav id="vendor-navigation">
              <tab-nav-item
                v-for="(link, index) in links"
                :id="link.target"
                :key="link.target"
                :initial-active="index == 0"
                :mutate-url="false"
                :scroll-to="true"
              >
                {{ link.label }}
              </tab-nav-item>
            </tab-nav>
          </div>
          <div v-if="shouldShowSticky" class="h5 text-right text-truncate mb-0 d-none d-md-block">
            {{ name }}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TabNav from "./TabNav";
import TabNavItem from "./TabNavItem";

export default {
  name: "VendorNavigation",
  components: {
    TabNav,
    TabNavItem,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    sticky: {
      type: Boolean,
      required: false,
      default: false,
    },
    links: {
      type: Array,
      required: true,
    },
  },
  computed: {
    shouldShowSticky() {
      return this.hasScrolledDown && this.sticky;
    },
    ...mapGetters({
      hasScrolledDown: "vendorShow/getHasScrolledDownState",
    }),
  },
  mounted() {
    if (!this.sticky && "IntersectionObserver" in window) {
      new IntersectionObserver(entries => {
        const item = entries[0];
        this.setHasScrolledDown(!item.isIntersecting);
      }).observe(this.$el);
    }
  },
  methods: {
    ...mapActions({
      setHasScrolledDown: "vendorShow/setHasScrolledDown",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.sticky-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: $zi-high;
  display: flex;
  justify-content: center;
  background: $white;
  border-radius: $border-radius;
  box-shadow: $box-shadow-lg;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity $transition-duration;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
